import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Row,
  Col,
  Label,
  Input,
  FormFeedback
} from "reactstrap"
import i18n from "../../../i18n"
import { putCostCenterUpdatePolicyEmployee, getCostCenterCreatePolicyEmployee as onGetCostCenterCreatePolicyEmployee } from "../../../helpers/api_rombo_helper"
import SimpleAlertError from '../../../components/Alerts/SimpleAlertError'
import * as Yup from 'yup';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";

const EditPolicyCostCenterEmployeeModal = (props) => {

  const { selectCostCenter, selectEmployee, setReloadCostCenterEmployees, reloadCostCenterEmployees,
          setEditPolicyCostCenterEmployeeModal, isOpen, toggle, setShowAlertSuccess, setTextHeader, setTextBody, token } = props;

  const [policyEmployee, setPolicyEmployee] = useState({})
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const dispatch = useDispatch()

  useEffect(() => {
    setPolicyEmployee({})
    if(selectEmployee.id){
      onGetCostCenterCreatePolicyEmployee(token, selectCostCenter.id, selectEmployee.id)
        .then((response) => {
          setPolicyEmployee(response)
          autoformik.values.total_trips = response.total_trips
        })
        .catch((error) => {
          console.log("Error - onGetCostCenterCreatePolicyEmployee - ", error)
        })
    }
  }, [dispatch, selectEmployee, isOpen]);
  
  const autoformik = useFormik({
    initialValues: {
      total_trips: policyEmployee.total_trips
    },
    validationSchema: Yup.object({
      total_trips: Yup.number().required("Required"),
    })
  });

  const editCostCenterEmployee = () => {
    putCostCenterUpdatePolicyEmployee(token, selectCostCenter.id, selectEmployee.id, autoformik.values)
      .then((response) => {
        setShowAlertSuccess(true)
        setEditPolicyCostCenterEmployeeModal(false)
        setTextHeader(i18n.t("UpdatePolicyEmployee"))
        setTextBody(i18n.t("SuccessUpdatePolicyEmployee"))
        setReloadCostCenterEmployees(!reloadCostCenterEmployees)
      })
      .catch((error) => {
        console.log("Error - putCostCenterUpdatePolicyEmployee ", error);
        setErrorAlert(true)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
      })
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"xl"}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle} className="mb-0 pb-0">
          <p>{i18n.t("EditPolicyEmployeeByCostCenter", { name: selectEmployee.name, costCenterName: selectCostCenter.name })}</p>
        </ModalHeader>
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert} text={errorAlertMessage} />
          <Row>
            <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
              <Col xxl={3} md={3} xs={12}>
                <div className="col-sm-auto mb-2">
                  <Label className="visually" htmlFor="total_tripsInput">{i18n.t("TotalTrips")}</Label>              
                  <Input type="number" name="total_trips" className="form-control" id="total_tripsInput" placeholder={i18n.t("TotalTrips")}
                    value={autoformik.values.total_trips}
                    defaultValue={policyEmployee.total_trips}
                    onChange={autoformik.handleChange}
                    onBlur={autoformik.handleBlur}
                    invalid={
                      autoformik.touched.total_trips && autoformik.errors.total_trips ? true : false
                    } />
                  {
                    autoformik.errors.total_trips && autoformik.touched.total_trips ? (
                      <FormFeedback type="invalid">{autoformik.errors.total_trips}</FormFeedback>
                    ) : null
                  }
                </div>
              </Col>
            </Form>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-danger"
            type="button"
            onClick={editCostCenterEmployee}
          >
            {i18n.t("Save")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

EditPolicyCostCenterEmployeeModal.propTypes = {
  setShowAlertSuccess: PropTypes.func,
  setEditCostCenterModal: PropTypes.func,
  setNameNewCostCenter: PropTypes.func,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  token: PropTypes.object,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func
}

export default EditPolicyCostCenterEmployeeModal;
